/**
 * Ayuda — Ventas → Grupos de Clientes
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_SAL_ENTITY_GROUPS_ITEM = {
  id: 'entityGroups',
  screenId: 'adm-sal-entity-groups',
  label: 'Grupos de Clientes',
  description: 'Organizá a tus clientes en categorías y grupos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Los grupos te permiten clasificar clientes (por zona, tipo de negocio, condiciones comerciales, etc.). Después podés asignar esos grupos al cargar o editar un cliente, y usarlos en listas de precios, promociones o reportes.',
        paragraphs: [
          'Primero creás las categorías (el «contenedor»). Después creás los grupos dentro de cada categoría.',
          'Ejemplo: categoría «Zona» con grupos «Norte» y «Sur»; o categoría «Tipo» con grupos «Mayorista» y «Minorista».',
        ],
      },
      {
        title: 'Las dos pestañas de arriba',
        bullets: [
          'Categorías de grupos: donde definís las categorías (los «estantes» donde van los grupos).',
          'Grupos: donde creás cada grupo y lo vinculás a una categoría.',
        ],
        paragraphs: [
          'Tocá cada pestaña para cambiar de vista. Desde Ventas siempre trabajás con grupos de clientes (no de proveedores).',
        ],
      },
      {
        title: 'Pestaña Categorías de grupos — Ver la lista',
        intro: 'Al entrar en esta pestaña ves una lista con las categorías ya cargadas. Las columnas son:',
        bullets: [
          'Id: número interno de la categoría.',
          'Descripción: nombre de la categoría.',
          'Cliente / Proveedor: indica si esa categoría se usa para clientes, proveedores o ambos.',
          'Activo: si la categoría está en uso (Sí) o fue dada de baja (No).',
          'Ícono de lápiz: para modificar la categoría.',
        ],
        paragraphs: [
          'Arriba a la derecha está el botón verde + para cargar una categoría nueva.',
          'La opción «Solo activos» (arriba a la izquierda) filtra la lista para ver solo las categorías activas. Desmarcala si querés ver también las inactivas.',
          'Podés pasar de página si hay muchas categorías y descargar la lista.',
        ],
      },
      {
        title: 'Pestaña Categorías — Cargar o editar una categoría',
        intro: 'Al tocar + o el lápiz se abre una ventana con estos datos:',
        fields: [
          {
            label: 'Descripción',
            description: 'Nombre de la categoría. Es obligatorio (por ejemplo «Zona geográfica» o «Canal de venta»).',
          },
          {
            label: 'Cliente',
            description:
              'Marcá esta opción si la categoría sirve para agrupar clientes. Desde Ventas suele venir ya marcada.',
          },
          {
            label: 'Proveedor',
            description:
              'Marcá esta opción solo si la misma categoría también aplica a proveedores. Tenés que marcar al menos Cliente o Proveedor.',
          },
          {
            label: 'Activo (solo al editar)',
            description:
              'Al modificar una categoría existente podés desmarcar «Activo» para dejarla de usar sin borrar el historial.',
          },
        ],
        paragraphs: [
          'Tocá «Guardar» para confirmar o «Cancelar» para salir sin cambios.',
        ],
      },
      {
        title: 'Pestaña Grupos — Ver la lista',
        intro: 'En la pestaña Grupos ves todos los grupos creados. Las columnas son:',
        bullets: [
          'Id: número interno del grupo.',
          'Descripción: nombre del grupo (por ejemplo «Mayorista CABA»).',
          'Categoría: a qué categoría pertenece.',
          'Cliente / Proveedor: heredado de la categoría elegida.',
          'Activo: si el grupo está en uso.',
          'Ícono de lápiz: para modificar el grupo.',
        ],
        paragraphs: [
          'Como en Categorías, tenés el filtro «Solo activos», el botón + para agregar y la posibilidad de cambiar de página o descargar.',
        ],
      },
      {
        title: 'Pestaña Grupos — Cargar o editar un grupo',
        intro: 'Antes de crear grupos conviene tener al menos una categoría cargada. La ventana de alta o edición tiene:',
        fields: [
          {
            label: 'Categoría',
            description:
              'Elegí de la lista en qué categoría va este grupo. Es obligatorio. Debajo del campo el sistema muestra si esa categoría es para clientes, proveedores o ambos.',
          },
          {
            label: 'Descripción',
            description: 'Nombre del grupo. Es obligatorio (por ejemplo «Norte», «VIP», «Contado»).',
          },
          {
            label: 'Activo (solo al editar)',
            description: 'Podés desactivar un grupo que ya no uses, sin eliminarlo del sistema.',
          },
        ],
        paragraphs: [
          'Tocá «Guardar» para crear o actualizar el grupo.',
        ],
      },
      {
        title: 'Cómo se usa con los clientes',
        intro:
          'Cuando cargás o editás un cliente (menú Clientes), en la parte de «Grupos» podés marcar a qué grupos pertenece. Los grupos que veas ahí son los que hayas creado en esta pantalla, organizados por categoría.',
      },
    ],
  },
}
